module.exports = __webpack_public_path__ + "img/pc_banner_sup_wallet.cd6af63c.webp";